import { render, staticRenderFns } from "./MiniappQrcode.vue?vue&type=template&id=47454df7&"
var script = {}
import style0 from "./MiniappQrcode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports